import React, { useEffect, useState } from 'react';
import BackButton from "../../../Components/BackButton";
import TitlePages from "../../../Components/TitlePages";
import axios from 'axios';
import {
  Container,
  SizeContainer,
  Title,
  MainContainer,
  ButtonsDiv,
  ButtonCompanies,
  ButtonDeleteCompanies,
  ButtonAddCompanies,
  ButtonRequest,
  InputAddIndustry,
  UserDiv,
  ListPlayers,
  ContainerStock,
  CardInsumo,
  Wrapper
} from "./style";

const imagesProduto = [
  "./images/sausage_pcp.svg",
  "./images/chicken.svg",
  "./images/cut_chicken_pcp.svg",
  "./images/fries_pcp.svg"
]

const SetupMarketplace = () => {

  const [rodada, setRodada] = useState({})
  const [jogo, setJogo] = useState(null)
  const [produtos, setProdutos] = useState([])
  const [linguica, setLinguica] = useState(0)
  const [frango, setFrango] = useState(0)
  const [frangoCorte, setFrangoCorte] = useState(0)
  const [batata, setBatata] = useState(0)
  const [industries, setIndustries] = useState(null)
  const [MarketPlacesBase, setMarketPlacesBase] = useState([])
  const [showInputToAddIndustry, setShowInputToAddIndustry] = useState(false)
  const [nameIndustry, setNameIndustry] = useState('')
  const [showLista, setShowLista] = useState(false)
  const [idIndustria, setIdIndustria] = useState(0)
  const [showAllUsers, setShowAllUsers] = useState(false)
  const [listaPlayers, setListaPlayers] = useState(null)
  const [listaUsers, setListaUsers] = useState(null)
  const [loading, setLoading] = useState(false)

  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  //lista todos os jogadores da industria
  function listAllPlayers(id) {
    setIdIndustria(id)
    setShowLista(!showLista)
    setShowAllUsers(false)

    api.get(`/api/usuario/listarPorSupermercado/${id.supermercado}`)
      .then(response => setListaPlayers(response.data))
      .catch(error => {
        return Promise.reject(error)
      })
  }

  //lista de usuarios sem industria
  function listAllUsers() {

    window.scrollTo(0, -1000);

    setShowAllUsers(true)

    api.get(`/api/usuario/listarSemSupermercado/${jogo?.jogo}`)
      .then(response => setListaUsers(response.data))
      .catch(error => {
        return Promise.reject(error)
      })
  }

  const handleDataProduto = (produtoState, codJogo, produto, marketPlaceId) => {

    const dataProduto = {
      "codJogo": codJogo,
      "codSupermercado": marketPlaceId,
      "produto": produto,
      "quantidade": produtoState
    }

    return dataProduto

  }

  function handleSetValue(value, setStateValue) {

    if (setStateValue === "Linguiça Salsichão") {
      setLinguica(Number(value))
    } else if (setStateValue === "Peito de Frango") {
      setFrango(Number(value))
    } else if (setStateValue === "Coxa de Frango") {
      setFrangoCorte(Number(value))
    } else if (setStateValue === "Batata Frita") {
      setBatata(Number(value))
    }

  }

  function handleValue(value, isInsumo) {
    if (value === "Linguiça Salsichão") {
      return linguica
    } else if (value === "Peito de Frango") {
      return frango
    } else if (value === "Coxa de Frango") {
      return frangoCorte
    } else if (value === "Batata Frita") {
      return batata
    }

  }

  function addUserToIndustry(user, industry) {

    api.get(`/api/usuario/adicionarUsuarioSupermercado/${industry.supermercado}/${user.usuario}`)
      .then(response => {
        console.log(response)
        api.get(`/api/usuario/listarSemSupermercado/${jogo?.jogo}`)
          .then(response => {
            setListaUsers(response.data)
            api.get(`/api/usuario/listarPorSupermercado/${industry.supermercado}`)
              .then(response => setListaPlayers(response.data))
              .catch(error => {
                return Promise.reject(error)
              })
          })
          .catch(error => {
            return Promise.reject(error)
          })
      })
      .then(console.log(industry.supermercado, user.usuario))
  }

  async function handleAddIndustry() {

    if (nameIndustry.trim().length === 0) return
    if (!jogo?.jogo) return

    try {
      const data = {
        "codJogo": jogo?.jogo,
        "nome": nameIndustry,
        "aluguel": 90000,
        "investimentoInicial": 1000000,
        "investimentoSaldo": 1000000
      }

      const res = await api.post("/api/supermercado/cadastrar", data)

      const productsPromises = produtos.map(produto => {
        switch (produto.nome) {
          case "Linguiça Salsichão":
            return api.post("/api/estoque/cadastrar", handleDataProduto(linguica, jogo.jogo, { "produto": 7 }, res.data.supermercado))
          case "Peito de Frango":
            return api.post("/api/estoque/cadastrar", handleDataProduto(frango, jogo.jogo, { "produto": 8 }, res.data.supermercado))
          case "Coxa de Frango":
            return api.post("/api/estoque/cadastrar", handleDataProduto(frangoCorte, jogo.jogo, { "produto": 9 }, res.data.supermercado))
          case "Batata Frita":
            return api.post("/api/estoque/cadastrar", handleDataProduto(batata, jogo.jogo, { "produto": 10 }, res.data.supermercado))
        }
      })

      await Promise.all(productsPromises)
      getAllMarkets()
      setNameIndustry('')
      setShowInputToAddIndustry(false)
    } catch (e) {
      console.log(e);
    }

  }

  function deleteMarketPlace(market) {

    axios.delete(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/supermercado/apagar`, { data: market })
      .then(response => {
        getAllMarkets();
        setShowLista(false)
      })
      .catch(error => {
        console.log(error);
      })

  }

  function removeUserFromMarketPlace(userId, marketPlaceId) {

    api.delete(`/api/usuario/removerUsuarioSupermercado/${marketPlaceId}/${userId}`)
      .then(response => {
        api.get(`/api/usuario/listarSemSupermercado/${jogo?.jogo}`)
          .then(response => {
            setListaUsers(response.data)
            api.get(`/api/usuario/listarPorSupermercado/${marketPlaceId}`)
              .then(response => setListaPlayers(response.data))
              .catch(error => {
                return Promise.reject(error)
              })
          })
          .catch(error => {
            return Promise.reject(error)
          })
      })
      .catch(error => {
        return Promise.reject(error)
      })

  }

  async function fetchProducts() {
    try {
      api.get("/api/produto/listarTodos")
        .then(response => {
          const data = response.data
          data.pop()
          setProdutos(data)
        })
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchBaseMarket(MarketInGame) {
    try {
      api.get(`/api/supermercado/listarBase`)
        .then(response => {
          const mapToFiltered = MarketInGame.map(item => item.nome)
          const filteredMarket = response.data.filter(market => {
            return !mapToFiltered.includes(market?.nome)
          })
          setMarketPlacesBase(filteredMarket)
        })
    } catch (error) {
      console.log(error)
    }
  }

  function getAllMarkets() {

    if (!jogo?.jogo) return
    try {
      api.get(`/api/supermercado/listar/${jogo?.jogo}`)
        .then(response => {
          fetchBaseMarket(response.data)
          setIndustries(response.data)
        })
    } catch (error) {
      console.log(error)
    }

  }

  
  function clearAll() {
    setLinguica(0)
    setFrango(0)
    setFrangoCorte(0)
    setBatata(0)
    setNameIndustry('')
  }

  async function fetchActiveGame() {
    try {
      api.get("/api/jogo/obterJogoAtivo")
        .then(response => {
          setJogo(response.data)
          api.get(`/api/rodada/obterRodadaAtiva/${response.data?.jogo}`)
            .then(res => {
              setRodada(res.data)
            })
            .catch(e => console.log(e))
        })

    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchProducts()
    getAllMarkets()
    fetchActiveGame()

  }, [jogo])

  return (
    <Container>
      <SizeContainer>
        <TitlePages text="Setup Supermercado" />
        <BackButton path="/home" />
        <ContainerStock style={{
          marginBottom: 12
        }}>
          <span>
            Jogo ativo
          </span>

          <Wrapper>
            <UserDiv>
              {jogo ? (
                <>
                  <span>Iniciado por {jogo?.criacaoUsuario?.nome}</span>
                  <span style={{ lineHeight: 2 }}>Jogo criado em {new Date(String(jogo?.criacaoData)).toLocaleDateString()}</span>
                  <span>Número de rodadas: {jogo?.rodadas}</span>
                  <span style={{ lineHeight: 2 }}>Rodada ativa atualmente: {rodada?.numero}</span>
                </>
              ) : (
                <span>Nenhum jogo ativo, inicie um novo jogo</span>
              )}
            </UserDiv>
          </Wrapper>

        </ContainerStock>
        <Title>
          Número de Supermercados <span>{industries?.length}</span>
        </Title>
        <MainContainer>

          <ButtonsDiv >
            <ButtonAddCompanies onClick={() => setShowInputToAddIndustry(!showInputToAddIndustry)} >+</ButtonAddCompanies>
          </ButtonsDiv>
          {
            showInputToAddIndustry ? (

              <>
                <ButtonsDiv style={{
                  width: '100%',
                  flexDirection: 'row',
                  flexWrap: 'wrap'
                }}>
                  {MarketPlacesBase?.map(market => (
                    <ButtonCompanies
                      style={nameIndustry === market?.nome ? {
                        height: 48,
                        padding: '0 15px',
                        border: 'solid 5px #FFA500'
                      } : { height: 48, padding: '0 15px' }}
                      key={market?.id}
                      onClick={() => {
                        if (nameIndustry === market?.nome) {
                          setNameIndustry('')
                        } else {
                          setNameIndustry(market?.nome)
                        }
                      }} >{market.nome}</ButtonCompanies>
                  ))
                  }
                </ButtonsDiv>

                {nameIndustry.length > 0 ? (
                  <ContainerStock>
                    <span>
                      <img src="./images/stock.svg" alt="icon_stock" />
                      Escolha o estoque inicial dos produtos
                    </span>
                    <section>
                      {produtos?.map((produto, key) => {
                        return (
                          <CardInsumo key={key}>
                            <img src={imagesProduto[key]} />
                            <h2>{produto.nome}</h2>
                            <div>
                              <input type={"number"} value={handleValue(produto.nome, false)} onChange={(e) => handleSetValue(e.target.value, produto.nome, false)} />
                              <p>
                                {produto.nome === "Embalagem Plástica" ?
                                  "Milhei." :
                                  produto.nome === "Caixa (Papelão)" ?
                                    "Uni." :
                                    "Kg"
                                }
                              </p>
                            </div>
                          </CardInsumo>
                        )
                      })}
                    </section>

                    <div role="button" onClick={loading ? () => { } : handleAddIndustry} style={{
                      marginTop: 10,
                      padding: '20px',
                      fontSize: 18,
                      fontWeight: 'bold',
                      backgroundColor: '#4bb543',
                      cursor: 'pointer',
                      textAlign: 'center'
                    }}>
                      Confirmar
                    </div>
                  </ContainerStock>
                ) : null

                }
              </>

            ) : null
          }
          <span>Supermercados ativos no jogo atual</span>
          {industries?.map((industry, k) => {
            return (
              <div key={k}>
                <ButtonsDiv  >
                  <ButtonCompanies onClick={() => listAllPlayers(industry)} >{industry.nome}</ButtonCompanies>
                  <ButtonDeleteCompanies onClick={() => deleteMarketPlace(industry)} >X</ButtonDeleteCompanies>
                </ButtonsDiv>
              </div>
            )
          })}
          {
            showLista ? (
              <UserDiv style={{ marginBottom: 30 }}>

                <span>Jogadores em {idIndustria.nome}:</span>
                <ListPlayers>
                  {listaPlayers?.length ?
                    listaPlayers.map((player, key) => {

                      return <div>
                        <ButtonDeleteCompanies onClick={() => removeUserFromMarketPlace(player.usuario, idIndustria.supermercado)} >X</ButtonDeleteCompanies>
                        <span key={key}>{player.nome} | {player.login}</span>

                      </div>
                    }) :
                    (

                      <span>Não há nenhum jogador nessa indústria, para adicionar clique no botão abaixo</span>

                    )
                  }

                </ListPlayers>

                {showAllUsers &&
                  <>
                    <span>Usuarios:</span>
                    <ListPlayers>

                      {listaUsers?.length ?
                        listaUsers.map((user, key) => {

                          return <div>
                            <span key={key}><ButtonAddCompanies onClick={() => addUserToIndustry(user, idIndustria)} >+</ButtonAddCompanies>{user.nome} | {user.login}</span>
                          </div>
                        }) :
                        (

                          <span>Todos os jogadores já estão vinculados a uma industria</span>

                        )
                      }


                    </ListPlayers>
                  </>
                }

                {!showAllUsers &&
                  <ButtonCompanies style={{ color: "orange", background: "#fff" }} onClick={() => listAllUsers()} >Adicionar Novo Jogador</ButtonCompanies>
                }


              </UserDiv>


            ) : (<></>)
          }
          <ButtonRequest>EXPORTAR</ButtonRequest>
        </MainContainer>
      </SizeContainer>
    </Container >
  );
};
export default SetupMarketplace;
